export default "__VITE_ASSET__d1ec8157__"